import React, { useContext, useEffect, useState } from 'react'

import { CSVLink } from 'react-csv'

import Menu from '../../components/UI/UIMenu'
import Modal from '../../components/UI/UIModal'
import UITextInput from '../../components/UI/UITextInput'
import UISubHeaderComponent from '../../components/UI/UISubHeaderComponent'
import { Icon } from '../../components/Icon'

import { TrainingHeader } from '../../data/index'
// import Pagination from '../../components/UI/Pagination'
import UIButton from '../../components/UI/UIButton'
// import UIDocumentPicker from '../../components/UI/UIDocumentPicker'

import UiSelect from '../../components/UI/UISelect'
import '../../App.css'
import { useQuery } from 'react-query'
import { getTraningById, getTraningRecord } from './apiCall'
import { formatDate, formatDateToUsDate } from '../../utils/utils'
import Loading from '../../components/UI/Loading'
import {
  // calculatePageCount,
  checkEmptyFields,
  getStatus,
  statusBgColor,
} from './utils'
import {
  deleteTraningRecord,
  updateTraningRecord,
} from '../../api/admin/trainingRecord'
import {
  traningCategories,
  traningTrackingRecordResponse,
} from '../../utils/types'
import { toast } from 'react-toastify'
import UIDatePickerv from '../../components/UI/UIDatePickerv'
import UIMultiSelect from '../../components/UI/UIMultiSelect'
import {
  exportToExcel,
  handleDownloadHtml,
  handleDownloadTxt,
  lastStr,
} from '../policy/utils'
import { UIExportHtmlTable } from '../../components/UI/UIExportHtmlTable'
import { useToggledSwitches } from '../../context/ToggledSwitchesContext'
import { SidebarContext } from '../../context/SidebarContext'
import PdfViewer from '../../components/UI/PdfViewer'

interface formData {
  certificateNumber: string
  date: string
  reviewDate: string
  verifiedBy: string
  verificationDate: string
  riskAssessmentStatus: string
  duration: string
  certificate: string
}

const Training = () => {
  const { toggledSwitches } = useToggledSwitches()
  const { viewBool, setViewBool } = useContext(SidebarContext)
  function getStoredIds(key: string): string[] {
    // Retrieve the JSON string from local storage
    const storedIdsString = localStorage.getItem(key)

    // Parse the JSON string and return it as an array
    if (storedIdsString) {
      try {
        const storedIds = JSON.parse(storedIdsString)

        // Ensure that the parsed data is an array of strings
        if (
          Array.isArray(storedIds) &&
          storedIds.every((id) => typeof id === 'string')
        ) {
          return storedIds
        } else {
          console.error('Parsed data is not an array of strings.')
          return []
        }
      } catch (error) {
        console.error('Failed to parse JSON string:', error)
        return []
      }
    }

    // Return an empty array if there's no data in local storage
    return []
  }

  const schoolIds = getStoredIds('SchoolIds')
  const [isOpenPdfViewer, setIsOpenPdfViewer] = useState<boolean>(false)
  const [pdfUrl, setPdfUrl] = useState('')
  const [isExportOpen, setIsExportOpen] = useState<boolean>(false)
  const [isConfrim, setIsConfrim] = useState<boolean>(false)
  const [traningObj, setTraningObj] = useState({
    certificateNumber: '',
    date: '',
    reviewDate: '',
    verifiedBy: '',
    verificationDate: '',
    riskAssessmentStatus: '',
    duration: '',
    certificate: '',
  })
  const [categoryName, setCategoryName] = useState('')

  const [isOpenEditTRModal, setIsOpenEditTRModal] = useState<boolean>(false)
  const [isOpenDeleteTRModal, setIsOpenDeleteTRModal] = useState<boolean>(false)

  const [sId, setSId] = useState<string | undefined>('')

  const [isView, setIsView] = useState<boolean>(viewBool)

  // const [currentPage, setCurrentPage] = useState<number>(1)
  // const [currentPage2, setCurrentPage2] = useState<number>(1)
  const [traningId, setTraningId] = useState('')
  const [fileType, setFileType] = useState<string>('')
  const [fileHeader] = useState([
    { key: 'Username', label: 'Username' },
    { key: 'Category', label: 'Category' },
    { key: 'Status', label: 'Status' },
    { key: 'Certificate_Number', label: 'Certificate Number' },
    { key: 'Next_Review_Date', label: 'Next Review Date' },
    { key: 'Completed', label: 'Completed' },
  ])
  const [sortOrderTraningRecords, setSortOrderTraningRecords] = useState<{
    [key: string]: 'asc' | 'desc'
  }>({})
  const [sortByTraningRecords, setSortByTraningRecords] =
    useState<string>('userName')
  const [sortOrderValueTraningRecords, setSortOrderValueTraningRecords] =
    useState<string>('asc')

  const traningRecords = useQuery('policy', () =>
    getTraningRecord(
      toggledSwitches.length > 0 ? toggledSwitches : schoolIds,
      // currentPage,
      sortByTraningRecords,
      sortOrderValueTraningRecords
    )
  )

  const [isOpenMenu, setIsOpenMenu] = useState<boolean[]>(
    new Array(traningRecords.data?.data?.length || 100).fill(false)
  )
  const singleTraning = useQuery(
    ['traning', traningId],
    () => getTraningById(traningId, sId),
    {
      enabled: !!traningId, // Only fetch data when id is truthy
    }
  )

  const handleSortTraningRecords = (key: string) => {
    const newSortOrder = { ...sortOrderTraningRecords }
    // console.log(' newSortOrder[key]', key)
    if (newSortOrder[key] === 'asc' || newSortOrder[key] === undefined) {
      // console.log(' newSortOrder[testjdjsn]', newSortOrder[key])
      newSortOrder[key] = 'desc'
      setSortByTraningRecords(key)
      setSortOrderValueTraningRecords('desc')
    } else {
      newSortOrder[key] = 'asc'
      setSortByTraningRecords(key)
      setSortOrderValueTraningRecords('asc')
    }
    setSortOrderTraningRecords(newSortOrder)
  }

  useEffect(() => {
    traningRecords.refetch() // Refetch Traning Records when sortBy or sortOrderValue changes
  }, [sortByTraningRecords, sortOrderValueTraningRecords])

  // const handlePageChange = (pageNumber: number): void => {
  //   setCurrentPage(pageNumber)
  // }
  // const handlePageChange2 = (pageNumber: number): void => {
  //   setCurrentPage2(pageNumber)
  // }

  const handleToggleMenu = (rowIndex: number) => {
    const updatedMenuState = isOpenMenu.map((isOpen, index) =>
      index === rowIndex ? !isOpen : false
    )
    setIsOpenMenu(updatedMenuState)
  }

  const handleExportOpenModal = () => {
    setIsExportOpen(true)
  }

  const handleExportCloseModal = () => {
    setIsExportOpen(false)
  }

  const handleChange = (fieldName: string, value: string): void => {
    setTraningObj((prevState) => ({
      ...prevState,
      [fieldName]: value,
    }))
  }

  const removeTraningRecord = async (): Promise<void> => {
    try {
      const response = (await deleteTraningRecord({ id: traningId })) as {
        status?: string
        data: traningTrackingRecordResponse
      }
      if (response?.status == 'successful') {
        traningRecords.refetch()
        setIsOpenDeleteTRModal(false)
        setIsView(false)
        toast.success('Deleted.', {
          position: 'top-right',
        })
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      toast.error('An error occurred while deleting partner.', {
        position: 'top-right',
      })
    }
  }

  const editTraningRecord = async (): Promise<void> => {
    console.log(traningId)
    const response = (await updateTraningRecord(traningObj, traningId)) as {
      status?: string
      data: traningCategories
    }
    if (response?.status == 'successful') {
      traningRecords.refetch()
      singleTraning.refetch()
      setIsOpenEditTRModal(false)

      // setIsOpen(!isOpen)

      toast.success('Traning Record Updated.', {
        position: 'top-right',
      })
    } else {
      toast.error('Network Error.', {
        position: 'top-right',
      })
    }
  }

  // useEffect(() => {
  //   categories.refetch()
  // }, [currentPage2])

  // useEffect(() => {
  //   traningRecords.refetch()
  // }, [currentPage])

  const columns = [
    {
      title: 'User Name',
      column: 'userName',
    },

    {
      title: 'Category',
      column: 'CategoryName',
    },
    {
      title: 'Status',
      column: 'status',
    },
    {
      title: 'Certificate Number',
      column: 'certificateNumber',
    },
    {
      title: 'Next Review Date',
      column: 'reviewDate',
    },
    // {
    //   title: 'Completed',
    //   column: 'Yes',
    // },
  ]
  useEffect(() => {
    setIsView(viewBool)
  }, [viewBool])

  return (
    <div
      className={'flex flex-col gap-6 w-full bg-white  h-full rounded-3xl p-8 '}
    >
      {!isView && (
        <div className="flex flex-col gap-6 w-full relative h-full">
          <div className={'flex w-full justify-between items-start '}>
            <div className="flex-col w-[50%] gap-[20px]">
              <p className={'text-[18px] text-text2 font-bold '}>
                Training Records
              </p>
              {/* <p
                className={'text-sm font-normal text-text1 leading-[24px] mt-2'}
              >
                Please use the export button to download client agreements: To
                export these results, select which columns you’d like and then
                choose a file format to export.
              </p> */}
            </div>
            <div className={'flex flex-row gap-[15px]'}>
              {/* <div
                onClick={() => setIsView('Manage Categories')}
                className="gap-[10px] bg-gray2 items-center justify-between min-w-[95px] h-12 px-[20px] flex rounded-[72px] cursor-pointer"
              >
                <p className={'font-semibold text-sm leading-6 text-text1'}>
                  Manage Categories
                </p>
                <Icon
                  name={'IconList'}
                  strokeWidth={1.2}
                  stroke={'#02698C'}
                  width={16}
                  height={16}
                />
              </div> */}
              <div
                onClick={() => {
                  if (traningRecords?.data?.data?.length != 0) {
                    handleExportOpenModal()
                  } else {
                    toast.info('No data available.', {
                      position: 'top-right',
                    })
                  }
                }}
                className="gap-[10px]  bg-bluishGreen items-center justify-between min-w-[95px] text-white h-12 px-[20px] flex rounded-[72px] cursor-pointer"
              >
                <p className={'font-semibold text-sm leading-6 text-white'}>
                  Export Data
                </p>
                <Icon
                  name={'IconShare'}
                  strokeWidth={1.2}
                  stroke={'white'}
                  width={16}
                  height={16}
                />
              </div>
            </div>
          </div>
          {/* content container */}
          <div className="relative h-full overflow-y-auto">
            <div className=" max-h-full h-full overflow-y-auto">
              {traningRecords.isLoading && (
                <div className="flex-col  w-[100%] p-[10px]">
                  <Loading size="large" />
                </div>
              )}
              {!traningRecords.isLoading && (
                <>
                  <table className="min-w-full table-auto divide-y-4 divide-white">
                    <thead className="sticky top-0 z-10 mb-4">
                      <tr className="bg-gray2 rounded-lg h-10 mb-18">
                        {TrainingHeader?.map((item, index: number) => {
                          return (
                            <th
                              key={index}
                              className={`px-4 py-3 text-left ${index === 0 ? 'rounded-l-lg' : ''} ${index === TrainingHeader.length - 1 ? 'border-none' : 'border-r border-white'}`}
                            >
                              <div className="flex items-center">
                                <p className="text-text1 font-semibold text-sm flex-1">
                                  {item.heading}
                                </p>
                                <div
                                  className={`cursor-pointer  ${item.icon == true ? 'flex' : 'hidden'}  `}
                                  onClick={() => {
                                    // console.log('valueeyyyyyyyyy--->', sortBy)
                                    handleSortTraningRecords(item.key)
                                  }}
                                >
                                  <Icon
                                    name={'IconChevronDown'}
                                    width={16}
                                    height={16}
                                    strokeWidth={1}
                                    stroke={'#67A5B9'}
                                  />
                                </div>
                              </div>
                            </th>
                          )
                        })}
                        <th className="w-[56px] rounded-r-lg"></th>{' '}
                      </tr>
                    </thead>
                    <tbody>
                      {traningRecords?.data?.data?.map((item, index) => (
                        <>
                          <tr key={index} className="bg-gray1">
                            <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                              <div
                                className={`flex gap-1 items-center w-fit rounded-[40px] px-3 py-2 bg-gray2`}
                              >
                                <p className="text-xs text-text3 font-medium">
                                  {item.firstName} {item.lastName}
                                </p>
                              </div>
                            </td>
                            <td className="px-4 font-medium text-textError text-[12px] h-[48px] py-2 border border-white">
                              <p className="flex-1 text-sm text-text1 leading-6 font-semibold">
                                {item.title}
                              </p>
                            </td>
                            <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                              <div
                                className={`rounded-[40px] w-fit px-3 py-2 bg-${statusBgColor(getStatus(formatDate(item.reviewDate || '')))}`}
                              >
                                <p className="text-xs text-text2 font-medium">
                                  {getStatus(formatDate(item.reviewDate || ''))}
                                </p>
                              </div>
                            </td>

                            <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                              <p className="flex-1 text-sm text-text1 leading-6 font-semibold">
                                {item.certificateNumber}
                              </p>
                            </td>
                            <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                              <p className="flex-1 text-sm text-text1 leading-6 font-semibold">
                                {formatDate(item.reviewDate || '')}
                              </p>
                            </td>

                            <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border-b border-white">
                              <p className="flex-1 text-sm text-text1 leading-6 font-semibold">
                                {/* {item.verifiedBy == null ? 'No' : 'Yes'} */}
                                {item.firstName} {item.lastName}
                              </p>
                            </td>

                            <td className="px-4 items-center justify-center flex relative   h-[48px] py-2 border-b border-white">
                              <Menu
                                isOpen={isOpenMenu[index]}
                                items={[
                                  {
                                    label: 'View',
                                    onClick: () => {
                                      setIsView(true)
                                      setViewBool(true)
                                      setSId(item?.schoolId)
                                      setCategoryName(item.title || '')
                                      setTraningId(item.id || '')
                                      if (item) {
                                        // delete item.title
                                        // delete item?.createdAt
                                        // delete item?.schoolId
                                        // delete item?.trainingRecordCategoryId
                                        // delete item?.updatedAt
                                        // delete item?.userId
                                        // delete item?.userName
                                        // delete item?.id
                                        // delete incidentById?.data?.createdByName
                                        setTraningObj({
                                          certificateNumber:
                                            item.certificateNumber,
                                          date: item.date,
                                          reviewDate: item.reviewDate,
                                          verifiedBy: item.verifiedBy,
                                          verificationDate:
                                            item.verificationDate,
                                          riskAssessmentStatus:
                                            item.riskAssessmentStatus,
                                          duration: item.duration,
                                          certificate: item.certificate,
                                        } as formData)
                                      }
                                      handleToggleMenu(index)
                                      console.log(item)
                                    },
                                    icon: 'IconEye',
                                    iconColor: '#02698C',
                                  },
                                  // {
                                  //   label: 'Edit',
                                  //   onClick: () => console.log('Edit'),
                                  //   icon: 'IconEdit',
                                  //   iconColor: '#02698C',
                                  // },
                                  // {
                                  //   label: 'Remove',
                                  //   onClick: () => {
                                  //     setIsOpenDeleteTRModal(true)
                                  //     setTraningId(item.id || '')
                                  //   },
                                  //   icon: 'IconTrash',
                                  //   iconColor: '#FF6666',
                                  //   textColor: 'text-textError',
                                  // },
                                ]}
                                setIsOpenMenu={setIsOpenMenu}
                                isOpenMenus={isOpenMenu}
                                type={'table'}
                              >
                                <div
                                  onClick={() => {
                                    handleToggleMenu(index)
                                    console.log(item.id)
                                    // setId(item.id)
                                  }}
                                >
                                  <Icon
                                    name={'IconDotsVertical'}
                                    width={16}
                                    height={16}
                                    strokeWidth={1.5}
                                    stroke={'#02698C'}
                                  />
                                </div>
                              </Menu>
                            </td>
                          </tr>
                        </>
                      ))}
                    </tbody>
                  </table>
                </>
              )}
              {/* <div className="absolute bottom-[20px]">
                <Pagination
                  currentPage={currentPage}
                  totalPages={calculatePageCount(
                    Number(traningRecords?.data?.count) || 0
                  )}
                  onPageChange={handlePageChange}
                />
              </div> */}
            </div>
          </div>
        </div>
      )}
      {isView == true && (
        <div style={{ height: 'calc(100vh - 100px)', overflow: 'auto' }}>
          <UISubHeaderComponent
            mainPage="Training Records"
            subPage={categoryName}
            onBack={() => setIsView(false)}
            copy=" Here you can edit and manage your training record. Upload and amend, change their review dates or set their status."
            onEdit={() => {
              setIsOpenEditTRModal(true)
            }}
            onDelete={() => {
              setIsOpenDeleteTRModal(true)
            }}
            isViewMode={true}
          />

          {/* content container */}

          <div className="overflow-hidden rounded-[16px] w-full my-[30px]">
            <table className="rounded-[16px] overflow-hidden border w-full border-white">
              <tbody>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[25%] h-[48px] py-2 border border-white">
                    Title
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] w-full h-[48px] py-2 border border-white">
                    {categoryName}
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[25%] h-[48px] py-2 border border-white">
                    Certificate Number
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] w-full h-[48px] py-2 border border-white">
                    {singleTraning?.data?.certificateNumber}
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[25%] h-[48px] py-2 border border-white">
                    Certificate File
                  </td>
                  <td className="px-4 py-2 w-full h-[48px] border border-white">
                    <div
                      onClick={() => {
                        const url = singleTraning?.data?.certificateUrl

                        if (!url) return

                        if ((url as unknown as string) == 'IN PROGRESS') {
                          return toast.warning(
                            'Scanning the file, please check again in a few seconds.',
                            {
                              position: 'top-right',
                            }
                          )
                        }
                        if ((url as unknown as string) == 'NoSuchKey') {
                          return toast.warning('File is removed', {
                            position: 'top-right',
                          })
                        }
                        setPdfUrl(`${url}`)
                        setIsOpenPdfViewer(true)
                      }}
                      className="px-4 py-2 gap-2 bg-white w-[268px] h-[48px] rounded-lg flex items-center"
                    >
                      <Icon
                        name={'IconFile'}
                        width={16}
                        height={16}
                        stroke="#02698C"
                        strokeWidth={1}
                      />
                      <p className="text-text1 font-semibold text-sm flex-1">
                        {lastStr(singleTraning?.data?.certificate)}
                      </p>
                      <Icon
                        name={'IconDownloadCloud'}
                        width={16}
                        height={16}
                        stroke="#02698C"
                        strokeWidth={1}
                      />
                    </div>
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[25%] h-[48px] py-2 border border-white">
                    Date
                  </td>
                  <td className=" px-4  text-text1 font-semibold text-[14px] w-full h-[48px] py-2 border border-white">
                    {singleTraning?.data?.date}
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[25%] h-[48px] py-2 border border-white">
                    Review Date
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] w-full h-[48px] py-2 border border-white">
                    {singleTraning?.data?.reviewDate}
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[25%] h-[48px] py-2 border border-white">
                    Verified
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] w-full h-[48px] py-2 border border-white">
                    {singleTraning?.data?.verificationDate}
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[25%] h-[48px] py-2 border border-white">
                    Verified by
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] w-full h-[48px] py-2 border border-white">
                    <div className="px-3 rounded-[72px] w-fit py-3 bg-gray2 flex gap-2 items-center">
                      <Icon
                        name={'IconUserCircle'}
                        width={16}
                        height={16}
                        stroke="#02698C"
                        strokeWidth={1}
                      />
                      <p>
                        {singleTraning?.data?.firstName}{' '}
                        {singleTraning?.data?.lastName}
                      </p>
                    </div>
                  </td>
                </tr>
                {/* Add more rows as needed */}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* modal */}

      <Modal
        customStyle={{ borderRadius: 16, padding: '16px 8px', width: '480px' }}
        isOpen={isExportOpen}
        onClose={handleExportCloseModal}
      >
        {isConfrim ? (
          <div
            className={
              'max-h-[100vh] overflow-scroll custom-scrollbar items-center flex flex-col gap-4 py-4 px-8'
            }
          >
            <div
              onClick={handleExportCloseModal}
              className="flex w-[100%] justify-end cursor-pointer"
            >
              <Icon
                name={'IconCross'}
                stroke="#02698C"
                height={16}
                width={16}
              />
            </div>
            <div className="flex items-center w-[100%] justify-center">
              <Icon
                name={'IconExportData'}
                height={52}
                width={52}
                strokeWidth={1}
                stroke="#02698C"
              />
            </div>
            <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
              <h1 className={'text-text2 text-lg font-bold leading-6'}>
                Export Data
              </h1>
              <p
                className={
                  'text-sm text-text1 font-normal leading-6 text-center'
                }
              >
                The CSV export file will be generated for download. Disable any
                popup blockers in your browser to ensure proper download.{' '}
                <span className="mt-3">Ok to proceed?</span>
              </p>
              <p
                className={
                  'text-sm text-text1 font-normal leading-6 mt-4 text-center'
                }
              >
                Ok to proceed?
              </p>
            </div>
            <div className="w-full flex flex-col gap-2 mt-2">
              {(fileType == 'Excel95' || fileType == 'Excel2007') && (
                <UIButton
                  label="Confirm"
                  onClick={() => {
                    exportToExcel(traningRecords?.data?.data, 'data', fileType)
                    handleExportCloseModal()
                    setIsConfrim(!isConfrim)
                  }}
                />
              )}
              {fileType == 'HTML' && (
                <UIButton
                  label="Confirm"
                  onClick={() => {
                    const html = UIExportHtmlTable({
                      columns: columns,
                      data: traningRecords?.data?.data || [],
                    })
                    if (html) {
                      handleDownloadHtml(html)
                      handleExportCloseModal()
                      setIsConfrim(!isConfrim)
                    }
                  }}
                />
              )}
              {fileType == 'Text' && (
                <UIButton
                  label="Confirm"
                  onClick={() => {
                    handleDownloadTxt(traningRecords?.data?.data)
                    handleExportCloseModal()
                    setIsConfrim(!isConfrim)
                  }}
                />
              )}
              {fileType == 'CSV' && (
                <CSVLink
                  target="_blank"
                  filename={'data.csv'}
                  headers={fileHeader}
                  data={
                    traningRecords?.data?.data?.map((item) => ({
                      Username: item.userName,
                      Category: item.title,
                      Status: item.reviewDate,
                      Certificate_Number: item.certificateNumber,
                      Next_Review_Date: item.reviewDate,
                      Completed: checkEmptyFields(item),
                    })) || []
                  }
                >
                  <UIButton
                    label="Confirm"
                    onClick={() => {
                      handleExportCloseModal()
                      setIsConfrim(!isConfrim)
                    }}
                  />
                </CSVLink>
              )}
              <UIButton
                secondary
                label="Cancel"
                onClick={() => setIsConfrim(!isConfrim)}
              />
            </div>
          </div>
        ) : (
          <div
            className={
              'max-h-[100vh] overflow-scroll custom-scrollbar items-center p-4 flex flex-col gap-4'
            }
          >
            <div
              onClick={handleExportCloseModal}
              className="flex w-[100%] justify-end cursor-pointer"
            >
              <Icon
                name={'IconCross'}
                stroke="#02698C"
                height={16}
                width={16}
              />
            </div>
            <div className="flex items-center w-[100%] justify-center">
              <Icon
                name={'IconExportData'}
                height={52}
                width={52}
                strokeWidth={1}
                stroke="#02698C"
              />
            </div>
            <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
              <h1 className={'text-text2 text-[18px] font-bold'}>
                Export Data
              </h1>
              <p className={'text-[14px] text-text1 font-normal'}>
                Please choose the data you want to export and file type.
              </p>
            </div>
            <div className="w-[420px] flex-col flex gap-4 my-[15px]">
              <UIMultiSelect
                options={[
                  { value: 'Username', label: 'Username' },
                  { value: 'Category', label: 'Category' },
                  { value: 'Status', label: 'Status' },
                  { value: 'Certificate_Number', label: 'Certificate Number' },
                  { value: 'Next_Review_Date', label: 'Next Review Date' },
                  { value: 'Completed', label: 'Completed' },
                ]}
                title={'Select Export Columns'}
              />
              <UiSelect
                title={'Choose Filetype'}
                placeholder="Please specify"
                labelClass={'text-xs'}
                onChange={(value) => setFileType(value)}
                selectedOptionClass={
                  'text-sm font-semibold leading-6 text-text4'
                }
                options={[
                  {
                    value: 'HTML',
                    label: 'HTML',
                    iconName: 'IconGlobe',
                  },
                  {
                    value: 'CSV',
                    label: 'CSV',
                    iconName: 'IconCodeSquare',
                  },
                  {
                    value: 'Text',
                    label: 'Text',
                    iconName: 'IconFile',
                  },
                  {
                    value: 'Excel95',
                    label: 'Excel 95 +',
                    iconName: 'IconBarChartCircle',
                  },
                  {
                    value: 'Excel2007',
                    label: 'Excel 2007 +',
                    iconName: 'IconBarChartSquare',
                  },
                ]}
              />
            </div>
            <div className="w-full">
              <button
                onClick={() => {
                  if (
                    fileType == 'CSV' ||
                    fileType == 'Text' ||
                    fileType == 'HTML' ||
                    fileType == 'Excel95' ||
                    fileType == 'Excel2007'
                  )
                    setIsConfrim(!isConfrim)
                }}
                className=" bg-bluishGreen text-white min-h-[48px] w-[98%] font-medium rounded-[72px] text-[14px]  "
              >
                Export Data
              </button>
            </div>
          </div>
        )}
      </Modal>
      {/* edit modal */}
      <Modal
        customStyle={{ borderRadius: 16, width: '480px' }}
        isOpen={isOpenEditTRModal}
        onClose={() => setIsOpenEditTRModal(false)}
      >
        <div
          className={
            'max-h-[80vh] overflow-scroll custom-scrollbar items-center px-4 py-2  flex flex-col gap-4'
          }
        >
          <div
            onClick={() => setIsOpenEditTRModal(false)}
            className="flex w-[100%] justify-end cursor-pointer"
          >
            <Icon name={'IconCross'} stroke="#02698C" height={16} width={16} />
          </div>
          <div className="flex items-center w-[100%] justify-center">
            <Icon name={'IconList'} stroke="#02698C" height={52} width={52} />
          </div>
          <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
            <p className={'text-text2 text-lg font-bold leading-6'}>
              Edit Training Record
            </p>
            <p className={'text-sm text-text1 font-normal leading-6'}>
              Please edit the training record details and attach your file
            </p>
          </div>
          <div className="w-full mt-3 flex flex-col gap-4">
            <UITextInput
              label={'Title*'}
              value={categoryName}
              readOnly={true}
              // onChange={() => {
              //   handleChange()
              // }}
              onBlur={() => {}}
              placeholder="Please enter your category title"
              iconName={'none'}
            />
            <UITextInput
              label={'Certificate Number'}
              onChange={(e) => {
                handleChange('certificateNumber', e.target.value)
              }}
              value={traningObj.certificateNumber}
              onBlur={() => {}}
              placeholder="Please enter your Certificate Number"
              iconName={'none'}
            />
            {/* <UIDocumentPicker label={'Policy Document*'} initialValue={null} /> */}

            <div className="flex">
              <div className="w-6/12 mr-1">
                <UIDatePickerv
                  placeholderText={'Not Specified'}
                  title={'Date'}
                  onChange={(e) => {
                    handleChange('date', e.target.value)
                  }}
                  value={formatDateToUsDate(traningObj.date)}
                />
              </div>
              <div className="w-6/12 ml-1">
                <UIDatePickerv
                  placeholderText={'Not Specified'}
                  title={'Review Date'}
                  onChange={(e) => {
                    handleChange('reviewDate', e.target.value)
                  }}
                  value={formatDateToUsDate(traningObj.reviewDate)}
                />
              </div>
            </div>
            {/* <div className="w-6/12">
            <UIDatePickerv
                      placeholderText={'Not Specified'}
                      title={'Review Date'}
                      onChange={(e) => {
                        handleChange('reviewDate', e.target.value)
                      }}
                      value={traningObj.reviewDate}
                    />
            </div> */}
            <UITextInput
              label={'Verified By'}
              onChange={(e) => {
                handleChange('verifiedBy', e.target.value)
              }}
              value={traningObj.verifiedBy}
              onBlur={() => {}}
              placeholder="Please enter name"
              iconName={'none'}
            />
            {/* <UiSelect
              options={[]}
              title={'Verified By'}
              placeholder="Not Specified"
            /> */}
          </div>
          <div className="w-full flex flex-col gap-3 mt-4">
            <UIButton
              label={'Update'}
              onClick={() => {
                editTraningRecord()
              }}
            />
            <UIButton
              label={'Cancel'}
              secondary
              onClick={() => {
                setIsOpenEditTRModal(false)
              }}
            />
          </div>
        </div>
      </Modal>
      {/* delete modal */}
      <Modal
        customStyle={{
          borderRadius: 16,
          padding: '20px 12px',
          width: '480px',
        }}
        isOpen={isOpenDeleteTRModal}
        onClose={() => setIsOpenDeleteTRModal(!isOpenDeleteTRModal)}
      >
        <div className={'max-h-[80vh] items-center p-4 flex flex-col gap-4'}>
          <div
            onClick={() => setIsOpenDeleteTRModal(!isOpenDeleteTRModal)}
            className="flex w-[100%] justify-end cursor-pointer"
          >
            <Icon name={'IconCross'} stroke="#02698C" height={16} width={16} />
          </div>
          <div className="flex items-center w-[100%] justify-center">
            <Icon
              name={'IconAlertTriangle'}
              stroke={'#FF6666'}
              strokeWidth={0.9}
              height={52}
              width={52}
            />
          </div>
          <div className="flex flex-col gap-2 items-center w-[100%] justify-center mb-5">
            <h1 className={'text-text2 text-lg font-bold leading-6'}>
              Delete Training Record
            </h1>
            <p className={'text-sm text-text1 font-normal leading-6'}>
              Are you sure you want to delete this training record?
            </p>
          </div>

          <button
            onClick={removeTraningRecord}
            className=" text-textError border-textError border-[1px] min-h-[48px] w-[95%] font-medium rounded-[72px] text-[14px]  "
          >
            Yes, I am Sure
          </button>
          <button
            onClick={() => setIsOpenDeleteTRModal(false)}
            className=" text-text3 border-textError bg-gray2 min-h-[48px] w-[95%] font-medium rounded-[72px] text-[14px]  "
          >
            Cancel
          </button>
        </div>
      </Modal>
      <PdfViewer
        isOpen={isOpenPdfViewer}
        onClose={() => {
          setIsOpenPdfViewer(false)
        }}
        url={pdfUrl}
        title="PDF Viewer"
      />
    </div>
  )
}

export default Training
